export default import.meta.ROLLDOWN_FILE_URL_18fBwEJ3jAY44oADWjyZjQ